import {
  Directive,
  ContentChildren,
  QueryList,
} from '@angular/core';
import {
  TooltipDirective,
  getTooltipOwner,
} from '@mhe/ngx-shared/tooltip';

@Directive({
  selector: '[rdrxHideOnEscape]',
  exportAs: 'rdrxHideOnEscape',
  standalone: false,
  host: {
    '(keydown.Escape)': 'handleEscapeKey($event)',
  },
})
export class HideOnEscapeDirective {
  // support multiple mheTooltips on children, such as in a tab group
  @ContentChildren(TooltipDirective, { descendants: true }) tooltips!: QueryList<TooltipDirective>;

  handleEscapeKey(event: Event): void {
    const initialClosed = this.closeInitialContentTooltips();
    const nestedClosed = this.closeNestedTemplateTooltips();

    // If any tooltip was closed, stop propagation of the event.
    if (initialClosed || nestedClosed) {
      event.stopPropagation();
    }
  }

  private closeInitialContentTooltips(): boolean {
    let handled = false;
    this.tooltips.toArray().forEach(tooltip => {
      if (tooltip.isOpen()) {
        tooltip.close();
        handled = true;
      }
    });
    return handled;
  }

  private closeNestedTemplateTooltips(): boolean {
    let handled = false;
    Array.from(document.querySelectorAll<HTMLElement>('div[role="tooltip"]')).forEach((tooltipElement) => {
      const parentTooltip = tooltipElement.closest<HTMLElement>('reader-ui-tooltip');
      const tooltipOwner = parentTooltip ? getTooltipOwner(parentTooltip) : undefined;
      if (tooltipOwner) {
        tooltipOwner.close();
        handled = true;
      }
    });
    return handled;
  }
}
